<div
  class="lg:h-screen px-20 h-screen-max bg-[#FDFFDC] effect bg-image bg-cover block h-screen w-screen"
  style="background-image: url(../../../../assets/Side-Illustration.png)">
  <ng-container *ngIf="!showCreatePass">
    <section class="sm:ml-17 ml-0" *ngIf="!twoFaVerification && !setup2FA && !showResetPassword">
      <article>
        <div
          class="w-[340px] bg-gray-900 opacity-95 p-8 pb-16 sm:mx-0 mx-auto rounded-br-[44px]"
          style="box-shadow: 0px 4px 28px 0px rgba(56, 30, 0, 0.15)">
          <div class="flex">
            <img class="w-32" src="../../../../assets/logo-white.svg" alt="" />
          </div>
          <section>
            <h1 class="mt-10 text-[24px] font-medium text-white">Welcome to Onafriq Partner Login</h1>
            <div class="mt-6">
              <!-- <form (ngSubmit)="onSubmit()">
                <div class="relative">
                  <onafriq-input
                    [label]="'Email Address'"
                    [placeholder]="''"
                    [(inputModel)]="username"
                    [width]="'full'"
                    [errorMsg]="''"
                    [dark]="true"
                    appNoSpace></onafriq-input>
                </div>

                <div class="my-6 relative">
                  <onafriq-input
                    [id]="'onboarding_login_input_2'"
                    [label]="'Password'"
                    [placeholder]="''"
                    [type]="'password'"
                    [(inputModel)]="password"
                    [width]="'full'"
                    [dark]="true"></onafriq-input>
                </div>

                <onafriq-button
                  width="full"
                  label="Login"
                  class="login-btn"
                  [buttonType]="'submit'"
                  [id]="'onboarding_login_btn_1'"
                  [disabled]="!username || !password" />
                <div class="text-sm text-red-500 text-center mt-4" *ngIf="showResponseErrorMessage">
                  {{ responseErrorMessage }}
                </div>
              </form> -->
              <p class="text-white">You are being redirected to the Reporting Portal</p>
            </div>
          </section>
        </div>
      </article>
    </section>
    <section class="sm:ml-17 ml-0" *ngIf="twoFaVerification && !setup2FA">
      <article>
        <div
          class="w-[340px] relative bg-gray-900 opacity-95 p-8 pb-16 sm:mx-0 mx-auto rounded-br-[44px]"
          style="box-shadow: 0px 4px 28px 0px rgba(56, 30, 0, 0.15)">
          <div class="flex gap-2 mb-4 cursor-pointer" (click)="twoFaVerification = false">
            <svg
              width="20"
              height="21"
              viewBox="0 0 20 21"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
              [id]="'onboarding_login_back_2'"
              class="cursor-pointer">
              <path
                d="M4.44023 10.5508L16.2402 10.5508"
                stroke="white"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round" />
              <path
                d="M9.46094 4.5L3.76094 10.55L9.46094 16.5"
                stroke="white"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round" />
            </svg>

            <span class="text-white"> Back</span>
          </div>
          <div>
            <img class="h-[50px] w-[176px]" src="assets/logo-white.svg" alt="" />
          </div>
          <div class="w-full mt-8" *ngIf="step == 0 && !resetEmailSent">
            <h1 class="text-h3 text-white font-radikal leading-normal font-medium">2-Step Verification</h1>

            <p class="text-sm text-white font-radikal-light">Enter the 6-digit code from your app</p>

            <div class="mt-[31px]">
              <form action="" method="post">
                <div class="flex items-center justify-center">
                  <onafriq-code-verification [darkMode]="true" (onInputFull)="submit2FA($event)" />
                  <div class="w-fit h-full ml-2 flex flex-col items-center">
                    <svg
                      *ngIf="!codeReady"
                      width="20"
                      height="20"
                      viewBox="0 0 20 20"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg">
                      <path
                        d="M9.99996 17.2909C14.0261 17.2909 17.29 14.0271 17.29 10.0009C17.29 5.97478 14.0261 2.71094 9.99996 2.71094C5.9738 2.71094 2.70996 5.97478 2.70996 10.0009C2.70996 14.0271 5.9738 17.2909 9.99996 17.2909Z"
                        stroke="#D9D9D8"
                        stroke-width="1.5"
                        stroke-linecap="round"
                        stroke-linejoin="round" />
                    </svg>
                    <svg
                      *ngIf="codeReady"
                      width="20"
                      height="20"
                      viewBox="0 0 20 20"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg">
                      <path
                        d="M13.1748 2.87483C13.5784 3.05465 13.7598 3.52758 13.58 3.93117C13.4001 4.33475 12.9272 4.51615 12.5236 4.33633C10.0155 3.21887 7.07114 3.88408 5.28715 5.97121C3.50318 8.05832 3.30457 11.0701 4.79902 13.3734C6.29348 15.6767 9.12504 16.7228 11.7581 15.9443C14.3115 15.1894 16.0883 12.8933 16.1951 10.2518L16.2002 10.0032V9.3522C16.2002 8.91038 16.5584 8.5522 17.0002 8.5522C17.408 8.5522 17.7446 8.85739 17.794 9.25185L17.8002 9.3522V10.0036C17.7982 13.4578 15.5244 16.4993 12.2118 17.4786C8.89919 18.458 5.33693 17.142 3.45679 14.2443C1.57664 11.3466 1.82651 7.55739 4.0709 4.93162C6.31528 2.30587 10.0195 1.469 13.1748 2.87483ZM18.5873 3.45583C18.8601 3.7506 18.8688 4.19571 18.6245 4.49969L18.5436 4.58636L9.90077 12.5864C9.62476 12.8418 9.21362 12.8674 8.91059 12.663L8.81391 12.5864L6.45677 10.4045C6.13252 10.1044 6.11297 9.59826 6.4131 9.27401C6.68595 8.97924 7.12906 8.93629 7.45098 9.15641L7.54363 9.23034L9.3562 10.9083L17.4568 3.41216C17.781 3.11203 18.2872 3.13159 18.5873 3.45583Z"
                        fill="#3ABF7C" />
                    </svg>
                  </div>
                </div>
              </form>
            </div>

            <div
              (click)="reset()"
              [id]="'onboarding_reset_2fa_2'"
              class="mt-7 text-sm underline font-radikal-light text-white cursor-pointer">
              Reset 2-Factor Authentication
            </div>
            <span class="mt-4 text-sm text-center text-red-500 block">
              {{ errMsg }}
            </span>
          </div>
          <div class="mt-6" *ngIf="resetEmailSent">
            <div class="w-full">
              <h3 class="text-h3 mb-3 font-bold text-white">A reset 2FA link has been sent to your email</h3>
              <svg width="56" height="56" viewBox="0 0 56 56" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M51.3307 25.8641V28.0108C51.3279 33.0424 49.6986 37.9383 46.6858 41.9683C43.6731 45.9984 39.4384 48.9465 34.6132 50.3732C29.7881 51.7998 24.631 51.6285 19.9112 49.8848C15.1913 48.141 11.1616 44.9183 8.42297 40.6972C5.68435 36.4762 4.38358 31.4829 4.71464 26.4622C5.04571 21.4414 6.99088 16.6622 10.26 12.8373C13.5292 9.01233 17.9472 6.34664 22.8552 5.23776C27.7631 4.12887 32.898 4.6362 37.4941 6.68409M51.3307 9.33073L27.9974 32.6874L20.9974 25.6874"
                  stroke="#33C27D"
                  stroke-width="6"
                  stroke-linecap="round"
                  stroke-linejoin="round" />
              </svg>

              <div class="text-xs font-radikal-light text-white mt-4 font-normal cursor-pointer">
                Having trouble? Contact
                <a class="underline" [id]="'onboarding_contact_us_2'" href="mailto:support@onafriq.com">{{
                  'support@onafriq.com'
                }}</a>
              </div>
            </div>
          </div>
        </div>
      </article>
    </section>
    <section class="sm:ml-17 ml-0" *ngIf="setup2FA">
      <article>
        <div
          class="w-[340px] bg-gray-900 opacity-95 p-8 pb-16 sm:mx-0 mx-auto rounded-br-[44px]"
          style="box-shadow: 0px 4px 28px 0px rgba(56, 30, 0, 0.15)">
          <div class="flex gap-2 mb-4 cursor-pointer" (click)="setup2FA = false">
            <svg
              width="20"
              height="21"
              viewBox="0 0 20 21"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
              [id]="'onboarding_login_back_2'"
              class="cursor-pointer">
              <path
                d="M4.44023 10.5508L16.2402 10.5508"
                stroke="white"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round" />
              <path
                d="M9.46094 4.5L3.76094 10.55L9.46094 16.5"
                stroke="white"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round" />
            </svg>

            <span class="text-white"> Back</span>
          </div>
          <div class="flex">
            <img class="w-32" src="../../../../assets/logo-white.svg" alt="" />
          </div>
          <div class="text-white mt-6 animate__animated animate__slideInRight animate-fast">
            <button
              class="bttn"
              (click)="skipButton()"
              *ngIf="!orgFlag"
              [ngStyle]="{ display: resetTwoFAFlag ? 'none' : 'block' }">
              Skip for now
            </button>

            <h3 class="font-medium text-h3">Setup 2-Factor Authentication</h3>
            <div class="mt-6 text-sm flex">
              <h2 class="font-bold mr-2 inline text-sm">1</h2>
              <div>
                <p class="hidden text-sm font-radikal-light md:inline">
                  Scan the QR Code below with any
                  <span class="font-medium font-radikal-medium">Authenticator App</span>
                  you have installed on your phone.
                </p>
                <p class="inline text-sm md:hidden">
                  Copy and paste the
                  <span class="font-bold">Authenticator Key</span>
                  below on any Authenticator App you have installed on your phone.
                </p>

                <svg
                  (click)="viewApps()"
                  [id]="'onboarding_view_apps_1'"
                  class="sm:hidden inline mx-[5px] cursor-help"
                  width="16"
                  height="16"
                  viewBox="0 0 16 16"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg">
                  <path
                    d="M7.99997 13.832C11.2209 13.832 13.832 11.2209 13.832 7.99997C13.832 4.77904 11.2209 2.16797 7.99997 2.16797C4.77904 2.16797 2.16797 4.77904 2.16797 7.99997C2.16797 11.2209 4.77904 13.832 7.99997 13.832Z"
                    stroke="#2F2F2E"
                    stroke-width="1.2"
                    stroke-linecap="round"
                    stroke-linejoin="round" />
                  <path
                    d="M6.44727 5.85735C6.74055 5.03243 7.58485 4.53817 8.44774 4.68626C9.31063 4.83436 9.94182 5.58184 9.94327 6.45735C9.94327 7.65735 8.14327 8.25735 8.14327 8.25735"
                    stroke="#2F2F2E"
                    stroke-width="1.2"
                    stroke-linecap="round"
                    stroke-linejoin="round" />
                  <path
                    d="M7.8957 12.057C8.33753 12.057 8.6957 11.6989 8.6957 11.257C8.6957 10.8152 8.33753 10.457 7.8957 10.457C7.45388 10.457 7.0957 10.8152 7.0957 11.257C7.0957 11.6989 7.45388 12.057 7.8957 12.057Z"
                    fill="#2F2F2E" />
                  <path
                    d="M7.89648 8.25781V9.15381"
                    stroke="#2F2F2E"
                    stroke-width="1.2"
                    stroke-linecap="round"
                    stroke-linejoin="round" />
                </svg>
                <svg
                  (mouseover)="viewApps()"
                  (mouseout)="hideApps()"
                  class="sm:inline hidden mx-[5px] cursor-help"
                  width="16"
                  height="16"
                  viewBox="0 0 16 16"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg">
                  <path
                    d="M7.99997 13.832C11.2209 13.832 13.832 11.2209 13.832 7.99997C13.832 4.77904 11.2209 2.16797 7.99997 2.16797C4.77904 2.16797 2.16797 4.77904 2.16797 7.99997C2.16797 11.2209 4.77904 13.832 7.99997 13.832Z"
                    stroke="#2F2F2E"
                    stroke-width="1.2"
                    stroke-linecap="round"
                    stroke-linejoin="round" />
                  <path
                    d="M6.44727 5.85735C6.74055 5.03243 7.58485 4.53817 8.44774 4.68626C9.31063 4.83436 9.94182 5.58184 9.94327 6.45735C9.94327 7.65735 8.14327 8.25735 8.14327 8.25735"
                    stroke="#2F2F2E"
                    stroke-width="1.2"
                    stroke-linecap="round"
                    stroke-linejoin="round" />
                  <path
                    d="M7.8957 12.057C8.33753 12.057 8.6957 11.6989 8.6957 11.257C8.6957 10.8152 8.33753 10.457 7.8957 10.457C7.45388 10.457 7.0957 10.8152 7.0957 11.257C7.0957 11.6989 7.45388 12.057 7.8957 12.057Z"
                    fill="#2F2F2E" />
                  <path
                    d="M7.89648 8.25781V9.15381"
                    stroke="#2F2F2E"
                    stroke-width="1.2"
                    stroke-linecap="round"
                    stroke-linejoin="round" />
                </svg>
              </div>
              <ng-container *ngIf="showApps">
                <!-- Show apps on Desktop -->
                <div
                  class="sm:flex hidden bg-gray-900 rounded-[6px] border-gray-200 card-box-shadow absolute left-[346px] top-[95px] w-[368px] h-fit flex-col items-center justify-center p-7.5">
                  <p class="text-sm">
                    Download
                    <span class="font-semibold">Authy, Google Authenticator, Sophos</span>
                    or your preferred Authenticator App.
                  </p>
                  <img class="mt-[12.5px]" src="assets/images/App logos.png" alt="AppLogos" />
                  <div
                    class="absolute left-[-22px] bottom-[50px] w-[42px] h-[42px] rotate-45 bg-gray-900 flex items-center justify-center border-l-gray-700"
                    style="
                      border-left: 1px solid var(--grey-400, #4a5052);
                      border-bottom: 1px solid var(--grey-400, #4a5052);
                    "></div>
                </div>
                <!-- Show apps on Mobile -->
                <onafriq-modal class="sm:hidden block">
                  <div
                    class="card-box-shadow mx-auto w-[340px] bg-gray-900 text-white border rounded-[12px] border-gray-200 flex flex-col items-center justify-center p-5 fixed top-[176px] left-1/2 transform -translate-x-1/2 -translate-y-1/2"
                    style="border: 1px solid var(--grey-200, #d9d9d8)">
                    <div class="flex items-start justify-between">
                      <p class="text-base font-radikal-light">
                        Download Authy, Google Authenticator, Sophos or your preferred Authenticator App.
                      </p>
                      <onafriq-icon (click)="hideApps()" icon="cancel" size="xs"></onafriq-icon>
                    </div>
                    <img class="mt-[12.5px]" src="assets/images/App logos.png" alt="AppLogos" />
                  </div>
                </onafriq-modal>
              </ng-container>
            </div>

            <div class="mt-6 flex justify-center items-center">
              <ng-container *ngIf="image">
                <img alt="QR-code" class="md:block hidden" width="110" height="110" [src]="image" />
              </ng-container>
            </div>

            <div class="mt-7.5 text-sm flex">
              <h2 class="font-bold mr-2 inline text-sm">2</h2>
              <p class="inline text-sm font-radikal-light">
                Enter the
                <span class="font-medium font-radikal-medium">6-digit Code </span>
                generated on your app and click Setup 2FA.
              </p>
            </div>
            <div class="my-8 flex">
              <form action="" method="post">
                <div class="flex items-center justify-center">
                  <onafriq-code-verification
                    (onInputFull)="enableUser2FA($event)"
                    [darkMode]="true"></onafriq-code-verification>
                  <div class="w-[59px] ml-4 h-full flex flex-col items-center">
                    <svg
                      *ngIf="!codeReady"
                      width="20"
                      height="20"
                      viewBox="0 0 20 20"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg">
                      <path
                        d="M9.99996 17.2909C14.0261 17.2909 17.29 14.0271 17.29 10.0009C17.29 5.97478 14.0261 2.71094 9.99996 2.71094C5.9738 2.71094 2.70996 5.97478 2.70996 10.0009C2.70996 14.0271 5.9738 17.2909 9.99996 17.2909Z"
                        stroke="#D9D9D8"
                        stroke-width="1.5"
                        stroke-linecap="round"
                        stroke-linejoin="round" />
                    </svg>
                    <svg
                      *ngIf="codeReady"
                      width="20"
                      height="20"
                      viewBox="0 0 20 20"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg">
                      <path
                        d="M13.1748 2.87483C13.5784 3.05465 13.7598 3.52758 13.58 3.93117C13.4001 4.33475 12.9272 4.51615 12.5236 4.33633C10.0155 3.21887 7.07114 3.88408 5.28715 5.97121C3.50318 8.05832 3.30457 11.0701 4.79902 13.3734C6.29348 15.6767 9.12504 16.7228 11.7581 15.9443C14.3115 15.1894 16.0883 12.8933 16.1951 10.2518L16.2002 10.0032V9.3522C16.2002 8.91038 16.5584 8.5522 17.0002 8.5522C17.408 8.5522 17.7446 8.85739 17.794 9.25185L17.8002 9.3522V10.0036C17.7982 13.4578 15.5244 16.4993 12.2118 17.4786C8.89919 18.458 5.33693 17.142 3.45679 14.2443C1.57664 11.3466 1.82651 7.55739 4.0709 4.93162C6.31528 2.30587 10.0195 1.469 13.1748 2.87483ZM18.5873 3.45583C18.8601 3.7506 18.8688 4.19571 18.6245 4.49969L18.5436 4.58636L9.90077 12.5864C9.62476 12.8418 9.21362 12.8674 8.91059 12.663L8.81391 12.5864L6.45677 10.4045C6.13252 10.1044 6.11297 9.59826 6.4131 9.27401C6.68595 8.97924 7.12906 8.93629 7.45098 9.15641L7.54363 9.23034L9.3562 10.9083L17.4568 3.41216C17.781 3.11203 18.2872 3.13159 18.5873 3.45583Z"
                        fill="#3ABF7C" />
                    </svg>
                  </div>
                </div>
              </form>
            </div>
            <div *ngIf="errMsg" class="my-8 test-xs text-red-500 font-normal">
              {{ errMsg }}
            </div>
            <div class="text-end w-full">
              <onafriq-button width="full" label="Setup 2FA" [disabled]="!isLoading" />
            </div>
          </div>
        </div>
      </article>
    </section>
    <section class="sm:ml-17 ml-0" *ngIf="showResetPassword">
      <article>
        <div
          class="w-[340px] bg-gray-900 opacity-95 p-8 pb-16 sm:mx-0 mx-auto rounded-br-[44px]"
          style="box-shadow: 0px 4px 28px 0px rgba(56, 30, 0, 0.15)">
          <div class="flex gap-2 mb-4 cursor-pointer" (click)="showResetPassword = false">
            <svg
              width="20"
              height="21"
              viewBox="0 0 20 21"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
              [id]="'onboarding_login_back_1'"
              class="cursor-pointer">
              <path
                d="M4.44023 10.5508L16.2402 10.5508"
                stroke="white"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round" />
              <path
                d="M9.46094 4.5L3.76094 10.55L9.46094 16.5"
                stroke="white"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round" />
            </svg>

            <span class="text-white"> Back</span>
          </div>
          <div class="flex">
            <img class="w-32" src="../../../../assets/logo-white.svg" alt="" />
          </div>
          <div
            class="text-white mt-6 flex flex-col gap-6 animate__animated animate__slideInRight animate-fast"
            *ngIf="!resetEmailSent">
            <h3 class="font-medium text-h3">Request Password Reset</h3>

            <onafriq-input
              [label]="'Email Address'"
              [placeholder]="''"
              [(inputModel)]="passwordResetEmail"
              [width]="'full'"
              [errorMsg]="''"
              [dark]="true"
              appNoSpace></onafriq-input>

            <div class="text-end w-full">
              <onafriq-button width="full" label="Send reset link" (onClick)="sendResetLink()" />
            </div>
          </div>
          <div class="mt-6" *ngIf="resetEmailSent">
            <div class="w-full">
              <h3 class="text-h3 mb-3 font-bold text-white">
                A reset password link has been sent to your email address.
              </h3>
              <svg width="56" height="56" viewBox="0 0 56 56" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M51.3307 25.8641V28.0108C51.3279 33.0424 49.6986 37.9383 46.6858 41.9683C43.6731 45.9984 39.4384 48.9465 34.6132 50.3732C29.7881 51.7998 24.631 51.6285 19.9112 49.8848C15.1913 48.141 11.1616 44.9183 8.42297 40.6972C5.68435 36.4762 4.38358 31.4829 4.71464 26.4622C5.04571 21.4414 6.99088 16.6622 10.26 12.8373C13.5292 9.01233 17.9472 6.34664 22.8552 5.23776C27.7631 4.12887 32.898 4.6362 37.4941 6.68409M51.3307 9.33073L27.9974 32.6874L20.9974 25.6874"
                  stroke="#33C27D"
                  stroke-width="6"
                  stroke-linecap="round"
                  stroke-linejoin="round" />
              </svg>

              <div class="text-xs font-radikal-light text-white mt-4 font-normal cursor-pointer">
                Having trouble? Contact
                <a class="underline" [id]="'onboarding_contact_us_2'" href="mailto:support@onafriq.com">{{
                  'support@onafriq.com'
                }}</a>
              </div>
            </div>
          </div>
        </div>
      </article>
    </section>
  </ng-container>

  <section class="sm:ml-17 ml-0" *ngIf="showCreatePass">
    <article>
      <div
        class="w-[340px] bg-gray-900 opacity-95 p-8 pb-16 sm:mx-0 mx-auto rounded-br-[44px]"
        style="box-shadow: 0px 4px 28px 0px rgba(56, 30, 0, 0.15)">
        <div class="flex">
          <img class="w-32" src="../../../../assets/logo-white.svg" alt="" />
        </div>
        <div
          class="text-white mt-6 flex flex-col gap-6 animate__animated animate__slideInRight animate-fast"
          *ngIf="!showPasswordChangedSuccess">
          <h3 class="font-medium text-h3">Create Password</h3>

          <onafriq-input
            [label]="'New Password'"
            [placeholder]="''"
            [(inputModel)]="newPassword"
            [width]="'full'"
            [errorMsg]="''"
            [type]="'password'"
            [dark]="true"
            appNoSpace></onafriq-input>

          <div class="mt-2 text-xs text-white text-left flex items-center justify-start">
            <ol class="text-white flex flex-col gap-1">
              <li>
                <span class="mr-1" *ngIf="_formService.containsUppercase(newPassword)">
                  <img class="inline h-3.5" src="assets/green-tick.svg" alt="green-tick" />
                </span>
                <span class="mr-1" *ngIf="!_formService.containsUppercase(newPassword) && confirmNewPassword.length">
                  <img class="inline h-3.5" src="assets/X-circle.svg" alt="X-circle" />
                </span>
                <span
                  [class.text-[#D90C34]]="!_formService.containsUppercase(newPassword) && confirmNewPassword.length"
                  class="inline-block ml-[2px]">
                  <span class="inline-block w-2.5">1.</span>At least 1 capital Letter</span
                >
              </li>
              <li>
                <span class="mr-1" *ngIf="_formService.containsSpecialChars(newPassword)">
                  <img class="inline h-3.5" src="assets/green-tick.svg" alt="green-tick" />
                </span>
                <span class="mr-1" *ngIf="!_formService.containsSpecialChars(newPassword) && confirmNewPassword.length">
                  <img class="inline h-3.5" src="assets/X-circle.svg" alt="X-circle" />
                </span>

                <span
                  [class.text-[#D90C34]]="!_formService.containsSpecialChars(newPassword) && confirmNewPassword.length"
                  class="inline-block ml-[2px]">
                  <span class="inline-block w-2.5">2.</span> At least 1 special character
                </span>
              </li>
              <li>
                <span class="mr-1" *ngIf="_formService.containsNumbers(newPassword)">
                  <img class="inline h-3.5" src="assets/green-tick.svg" alt="green-tick" />
                </span>
                <span class="mr-1" *ngIf="!_formService.containsNumbers(newPassword) && confirmNewPassword.length">
                  <img class="inline h-3.5" src="assets/X-circle.svg" alt="X-circle" />
                </span>

                <span
                  [class.text-[#D90C34]]="!_formService.containsNumbers(newPassword) && confirmNewPassword.length"
                  class="inline-block ml-[2px]"
                  ><span class="inline-block w-2.5">3.</span> At least 1 number</span
                >
              </li>
              <li>
                <span class="mr-1" *ngIf="newPassword.length >= 8">
                  <img class="inline h-3.5" src="assets/green-tick.svg" alt="green-tick" />
                </span>
                <span class="mr-1" *ngIf="newPassword.length < 8 && confirmNewPassword.length">
                  <img class="inline h-3.5" src="assets/X-circle.svg" alt="X-circle" />
                </span>

                <span
                  [class.text-[#D90C34]]="newPassword.length < 8 && confirmNewPassword.length"
                  class="inline-block ml-[2px]"
                  ><span class="inline-block w-2.5">4.</span> At least 8 characters in total</span
                >
              </li>
              <li *ngIf="newPassword.length && confirmNewPassword.length">
                <span class="mr-1" *ngIf="newPassword === confirmNewPassword">
                  <img class="inline h-3.5" src="assets/green-tick.svg" alt="green-tick" />
                </span>
                <span class="mr-1" *ngIf="newPassword !== confirmNewPassword">
                  <img class="inline h-3.5" src="assets/X-circle.svg" alt="X-circle" />
                </span>

                <span [class.text-[#D90C34]]="newPassword !== confirmNewPassword" class="inline-block ml-[2px]">
                  <span class="inline-block w-2.5">5.</span> Passwords must match</span
                >
              </li>
            </ol>
          </div>

          <onafriq-input
            [label]="'Confirm Password'"
            [placeholder]="''"
            [(inputModel)]="confirmNewPassword"
            [width]="'full'"
            [errorMsg]="''"
            [type]="'password'"
            [dark]="true"
            appNoSpace></onafriq-input>

          <div class="text-end w-full">
            <onafriq-button
              width="full"
              label="Create Password"
              (onClick)="createNewPassword()"
              [disabled]="!isPasswordValid()" />
          </div>
        </div>
        <div class="mt-6" *ngIf="showPasswordChangedSuccess">
          <div class="w-full">
            <h3 class="text-h3 mb-3 font-bold text-white">Your password has been successfully changed.</h3>
            <svg width="56" height="56" viewBox="0 0 56 56" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path
                d="M51.3307 25.8641V28.0108C51.3279 33.0424 49.6986 37.9383 46.6858 41.9683C43.6731 45.9984 39.4384 48.9465 34.6132 50.3732C29.7881 51.7998 24.631 51.6285 19.9112 49.8848C15.1913 48.141 11.1616 44.9183 8.42297 40.6972C5.68435 36.4762 4.38358 31.4829 4.71464 26.4622C5.04571 21.4414 6.99088 16.6622 10.26 12.8373C13.5292 9.01233 17.9472 6.34664 22.8552 5.23776C27.7631 4.12887 32.898 4.6362 37.4941 6.68409M51.3307 9.33073L27.9974 32.6874L20.9974 25.6874"
                stroke="#33C27D"
                stroke-width="6"
                stroke-linecap="round"
                stroke-linejoin="round" />
            </svg>

            <div class="text-xs font-radikal-light text-white mt-4 font-normal cursor-pointer">
              <a
                class="underline"
                (click)="
                  showPasswordChangedSuccess = false;
                  showCreatePass = false;
                  twoFaVerification = false;
                  setup2FA = false;
                  showResetPassword = false
                "
                >Go back to Login</a
              >
            </div>
          </div>
        </div>
      </div>
    </article>
  </section>
</div>

<onafriq-modal *ngIf="showResetModal">
  <div
    class="bg-white md:h-[191px] md:w-[482px] w-[95%] h-fit rounded-2xl p-7.5 fixed top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2"
    style="box-shadow: 0px 4px 28px 0px rgba(0, 47, 56, 0.25)">
    <h2 class="text-gray-900 text-h3">Are you sure you want to reset 2FA for user</h2>
    <p class="mt-4 text-gray-900 text-sm">A reset 2FA link will be sent to your email.</p>
    <div class="mt-6 flex gap-4 justify-end">
      <onafriq-button type="secondary" label="Cancel" (onClick)="showResetModal = false" />
      <onafriq-button label="Yes, I'm Sure" (onClick)="reset2FA()" />
    </div>
  </div>
</onafriq-modal>
